import { useState, useCallback } from "react";
import { message } from "antd";
import sdk from "../../sdk";

export const useKycQuestionnaireSend = ({
  questionnaireId,
}: {
  questionnaireId: string;
}) => {
  const [loading, setLoading] = useState(false);
  const [unrespondedCount, setUnrespondedCount] = useState<number | null>(null);

  const refreshUnrespondedCount = useCallback(() => {
    sdk
      .previewKycQuestionnaireUnrespondedCount({ questionnaireId })
      .then((res) =>
        setUnrespondedCount(res.previewKycQuestionnaireUnrespondedCount)
      )
      .catch((err) => {
        const msg =
          err?.response?.errors?.[0]?.message ??
          err?.message ??
          "Тоо ачаалах үед алдаа гарлаа.";
        message.warn(msg, 3);
      });
  }, [questionnaireId]);

  const sendToAllUnresponded = useCallback(() => {
    setLoading(true);
    sdk
      .sendKycQuestionnaireToAllUnresponded({ questionnaireId })
      .then((res) => {
        message.success(
          `${res.sendKycQuestionnaireToAllUnresponded} хэрэглэгчид амжилттай илгээгдлээ`,
          3
        );
        refreshUnrespondedCount();
      })
      .catch((err) => {
        const msg =
          err?.response?.errors?.[0]?.message ??
          err?.message ??
          "Алдаа гарлаа. Дахин оролдоно уу.";
        message.warn(msg, 3);
      })
      .finally(() => setLoading(false));
  }, [questionnaireId, refreshUnrespondedCount]);

  return {
    loading,
    unrespondedCount,
    refreshUnrespondedCount,
    sendToAllUnresponded,
  };
};
